export default __webpack_public_path__ + "static/media/PDF_file.a01d058a.svg";